<template>
    <div class="hyt-qr-code">
        <div class="name-logo">
            <div class="logo"><img src="./static/logo.png"></div>
            <p class="name">航天互联网诊疗平台</p>
        </div>
        <div class="tag-list">
            <p>在线咨询</p>
            <p class="m-tag">预约挂号</p>
            <p>复诊开药</p>
        </div>
        <div class="tag-list">
            <p>诊间缴费</p>
            <p class="m-tag">报告查询</p>
            <p>远程会诊</p>
        </div>
        <div class="hyt-code">
            <img src="./static/code.png">
        </div>
        <div class="info">
            微信扫描上方二维码或微信搜索<span>航医通</span>进入小程序使用
        </div>
    </div>
</template>
<script>
export default{
    data() {
        return {
            codeUrl: '链接'
        }
    },
    created () {
        this.gatData();
    },
    methods: {
        gatData() {
            console.log(this.codeUrl);
        }
    }
}
</script>
<style lang="less" scoped>
.hyt-qr-code{
    max-width: 1080px;
    margin: 0 auto;
    min-height: 100vh;
    width: 100%;
    font-size: 28px;
    background-image: url('./static/htBg.png');
    background-repeat: no-repeat;
    background-position:top center;
    background-size: cover;
    color: #FFFFFF;
    .name-logo{
        padding-top: 187px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 70px;
    }
    .name{
        font-size: 41px;
        display: flex;
        justify-content: center;
    }
    .logo{
        display: flex;
        justify-content: center;
        margin-bottom: 35px;
        img{
          width: 365px;
          height: 80px;
        }
    }
    .tag-list{
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: center;
        margin-bottom: 36px;
        p{
            float: left;
            font-size: 32px;
            border: 2px solid #fff;
            border-radius: 10px;
            width: 165px;
            height: 52px;
            display: flex;
            justify-content: center;
            align-items: center;
            &.m-tag{
                margin-left: 30px;
                margin-right: 30px;
            }
        }
    }
    .hyt-code{
        display: flex;
        justify-content: center;
        margin-top: 80px;
        margin-bottom: 66px;
        img{
            width: 335px;
            height: 381px;
        }
    }
    .info{
        display: flex;
        justify-content: center;
        margin: 0 42px;
        font-size: 26px;
        flex-wrap: wrap;
        line-height: 1.5;
        padding-bottom: 60px;
        span{
            display: inline-block;
            color: #FCEE21;
            margin-left:5px;
            margin-right:5px;
        }
    }
}
</style>